import { Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import { useGetCreditFacilityQuery } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { colors } from '../colors';
import { Icon } from './icons';
import { Select } from './Select';
import { errorToastConfig } from 'packages/common-frontend/constants';
import { getUnexpectedErrorMessage } from 'packages/common-frontend/utils';

type LoanProductSelectProps = {
  isDisabled?: boolean;
  creditFacilityId: string;
  loanProductId: string | null;
  setLoanProductId:
    | React.Dispatch<React.SetStateAction<string | null>>
    | React.Dispatch<React.SetStateAction<string>>;
  useAllOption?: boolean;
  allDefaultValue?: { value: string; label: string; icon: React.ReactElement };
};
export const LoanProductSelect = ({
  isDisabled,
  creditFacilityId,
  loanProductId,
  setLoanProductId,
  allDefaultValue = {
    value: 'all',
    label: 'All',
    icon: <Icon icon="shapes" />,
  },
  useAllOption,
}: LoanProductSelectProps) => {
  const toast = useToast();
  const { data, loading } = useGetCreditFacilityQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = getUnexpectedErrorMessage(err);
      toast(errorToastConfig);
    },
    variables: { creditFacilityId },
  });

  if (loading || !data?.creditFacility) {
    return <Skeleton />;
  }

  const {
    creditFacility: { loanProducts },
  } = data;

  const lpOptions = loanProducts.map(({ id, name }) => ({
    value: id,
    label: name,
    icon: <Icon icon="money-bill" />,
  }));

  const options = useAllOption ? [allDefaultValue, ...lpOptions] : lpOptions;

  return (
    <Select
      isDisabled={!!isDisabled}
      inputFloatingLabel="Loan Product"
      inputFloatingLabelBackgroundColor={colors.white}
      options={options}
      value={loanProductId ?? loanProducts[0].id}
      onChange={(newLoanProductId?: string) => {
        if (newLoanProductId) {
          setLoanProductId(newLoanProductId);
        }
      }}
      width="300px"
    />
  );
};
